<ng-container *ngIf="order">
  <div class="row">
    <div class="col-md-4 no-padding-right order-info-box">
      <app-card [title]="'admin.backoffice.order.information'|translate">
        <div class="row">
          <table class="table ms-3 col delivery-week-table">
            <tbody>
            <tr>
              <td class="pb-2">{{'doctrine.backoffice.order.number'|translate}}</td>
              <td class="pb-2">{{order.orderNo}}</td>
            </tr>
            <tr>
              <td class="pb-2">{{'doctrine.backoffice.order.date'|translate}}</td>
              <td class="pb-2">{{order.created|DateFormat }}</td>
            </tr>
            <tr>
              <td class="pb-2">{{'doctrine.backoffice.order.reference'|translate}}</td>
              <td class="pb-2">{{order.reference}}</td>
            </tr>
            <tr *ngIf="order.remark">
              <td class="pb-2">{{'admin.order.remark'|translate}}</td>
              <td class="pb-2">
                {{order.remark.slice(0,20) + '...'}}
              </td>
            </tr>
            <tr *ngIf="!isQuote">
              <td class="pb-2">{{'doctrine.backoffice.order.ordered_by'|translate}}</td>
              <td class="pb-2">{{order.author.contact|titlecase}}</td>
            </tr>
            <tr>
              <td class="pb-2">{{'doctrine.backoffice.order.requested_delivery_week'|translate}}</td>
              <td class="pb-2">
                <ng-container>
                  {{order.deliveryWeek ? (order.deliveryWeek|WeekDateFormat) : ''}}
                </ng-container>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </app-card>
    </div>
    <div *ngIf="!isQuote" class="col-md-4 order-info-box">
      <app-card [title]="'admin.backoffice.order.delivery_information'|translate">
        <div class="row">
          <div class="col-md-5 infobox">
            <p>{{'doctrine.user.name'|translate}}</p>
            <p>{{'doctrine.user.address'|translate}}</p>
            <p>{{'doctrine.user.zipCode'|translate}}</p>
            <p>{{'doctrine.user.city'|translate}}</p>
            <p>{{'doctrine.user.country'|translate}}</p>
            <p>{{'doctrine.user.phone'|translate}}</p>
            <p>{{'doctrine.user.email'|translate}}</p>
          </div>
          <div *ngIf="order.customerDeliveryAddress" class="col-md-7 infobox">
            <p>{{order.customerDeliveryAddress?.fullName}}</p>
            <p>{{order.customerDeliveryAddress?.street + ' ' + order.customerDeliveryAddress?.houseNumber }}</p>
            <p>{{order.customerDeliveryAddress?.zipCode}}</p>
            <p>{{order.customerDeliveryAddress?.city}}</p>
            <p>{{order.customerDeliveryAddress?.country}}</p>
            <p>{{order.customerDeliveryAddress?.phoneNumber}}</p>
            <p>{{order.customerDeliveryAddress?.email}}</p>
          </div>
          <div *ngIf="!order.customerDeliveryAddress" class="col-md-7 infobox">
            <p>{{order.dealerDeliveryAddress?.companyName}}</p>
            <p>{{order.dealerDeliveryAddress?.address}}</p>
            <p>{{order.dealerDeliveryAddress?.postalCode}}</p>
            <p>{{order.dealerDeliveryAddress?.city}}</p>
            <p>{{order.dealerDeliveryAddress?.country?.name}}</p>
            <p>{{order.dealerDeliveryAddress?.phone}}</p>
            <p>{{order.dealerDeliveryAddress?.email}}</p>
          </div>
        </div>
      </app-card>
    </div>
  </div>

  <!--   Order-------------------------------------------------------------------->
  <div class="row">
    <div class="col-md-12">
      <app-card [title]="'admin.backoffice.order.title'|translate"
                [advanceButton]="true"
                [advancedButtons]="specialButton"
                (outputButtonAdvance)="calFunction($event)">
        <ng-template #orderTemplateRef let-order="order">
          <div class="row">
            <div class="col-md-12">
              <div class="form-radio pt-2 d-flex" *ngIf="!auth.isDealerUser()">
                <div class="radio radio-inline">
                  <label>
                    <input type="radio" name="radio" [value]="true" [(ngModel)]="selectedCustomPrice"
                           (change)="getDealerPrice(false)">
                    <i class="helper"></i>{{'doctrine.product.customer_price'|translate}}
                  </label>
                </div>
                <div class="radio radio-inline" >
                  <label>
                    <input type="radio" name="radio" [value]="false" [(ngModel)]="selectedCustomPrice"
                           (change)="getDealerPrice(true)">
                    <i class="helper"></i>{{'doctrine.product.dealer_price'|translate}}
                  </label>
                </div>
              </div>
              <div class="table-responsive order-table">
                <table class="table table-order">
                  <thead>
                  <tr>
                    <th>{{'doctrine.backoffice.order.article'| translate}}</th>
                    <th>{{'doctrine.backoffice.order.article_number'| translate}}</th>
                    <th>{{'doctrine.backoffice.order.amount'| translate}}</th>
                    <th>{{'doctrine.backoffice.order.price'| translate}}</th>
                    <th>{{'doctrine.backoffice.order.total'| translate}}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <!-- Products, Fabrics, Packages, Properties--->
                  <ng-container *ngFor="let orderItem of order.orderItems;let i=index">
                    <ng-container *ngFor="let orderItemProduct of orderItem.orderItemProducts; let m = index;">
                      <tr class="after-divider">
                        <ng-container *ngIf="orderItemProduct.product">
                          <td>
                            <!--Products-->
                            <p *ngIf="orderItemProduct.product">{{orderItem.model.name}} {{(orderItem.style ? orderItem.style.name : '')}} {{orderItemProduct.product.name}} {{carpetSizeLabel(orderItemProduct.widthCm, orderItemProduct.lengthCm)}}</p>
                            <!--Fabrics-->
                            <p class="ms-3 "
                               *ngIf="orderItemProduct.orderItemProductFabricCollections.length > 0 && checkHasFabric(orderItemProduct.orderItemProductFabricCollections[0])">
                              <ng-container *ngFor="let fabric of orderItemProduct.orderItemProductFabricCollections">
                                {{ 'doctrine.fabric.fabric'|translate}}:
                                {{(fabric.fabricCollection) ? fabric.fabricCollection.name + ',' : ''}}
                                <span *ngIf="fabric.fabricCollection.isCustom">
                                  {{fabric.fabricName+ ','}}
                                  {{fabric.fabricColorName }}
                                </span>
                                <span *ngIf="!fabric.fabricCollection.isCustom">
                                  {{(fabric.fabric) ? fabric.fabric.name + ',' : ''}}
                                  {{(fabric.fabricColor) ? fabric.fabricColor.name : '' }}
                                </span>
                              </ng-container>
                            </p>
                            <!--Packages-->
                            <ng-container
                              *ngFor="let orderItemProductPackage of orderItemProduct.orderItemProductPackages;">
                              <p class="ms-3 "
                                 *ngIf="orderItemProductPackage.orderItemProductPackageProducts[0] && orderItemProductPackage.orderItemProductPackageProducts[0].product">
                                {{orderItemProductPackage.package.name}}
                                <ng-container
                                  *ngFor="let orderItemProductPackageProduct of orderItemProductPackage.orderItemProductPackageProducts">
                                  <span>{{orderItemProductPackageProduct.product.name}}</span>
                                </ng-container>
                              </p>
                            </ng-container>
                          </td>
                          <!-- article number-->
                          <td>
                            <p>{{orderItemProduct.product.number}}</p>
                            <p *ngIf="orderItemProduct.orderItemProductFabricCollections.length > 0 && checkHasFabric(orderItemProduct.orderItemProductFabricCollections[0])">&nbsp;</p>
                            <!--Packages-->
                            <ng-container
                              *ngFor="let orderItemProductPackage of orderItemProduct.orderItemProductPackages;">
                              <p *ngIf="orderItemProductPackage.orderItemProductPackageProducts[0] && orderItemProductPackage.orderItemProductPackageProducts[0].product">
                                <ng-container
                                  *ngFor="let orderItemProductPackageProduct of orderItemProductPackage.orderItemProductPackageProducts">
                                  <span>&nbsp;</span>
                                </ng-container>
                              </p>
                            </ng-container>
                          </td>
                          <!--amount-->
                          <td>
                            <p *ngIf="orderItemProduct.product">{{orderItemProduct.amount}}</p>
                            <p *ngIf="orderItemProduct.orderItemProductFabricCollections.length >0 && checkHasFabric(orderItemProduct.orderItemProductFabricCollections[0])">

                              {{orderItemProduct.orderItemProductFabricCollections[0]?.fabricCollection?.isCustom ? "" + recalculateFabricAmount(orderItemProduct.orderItemProductFabricCollections[0], orderItemProduct.selectedPerProductOption?.urbanOption, orderItemProduct.amount, orderItemProduct)  : orderItemProduct.orderItemProductFabricCollections[0].amount }}
                            </p>
                            <!--Packages-->
                            <ng-container
                              *ngFor="let orderItemProductPackage of orderItemProduct.orderItemProductPackages;">
                              <p *ngIf="orderItemProductPackage.orderItemProductPackageProducts[0] && orderItemProductPackage.orderItemProductPackageProducts[0].product">
                                <ng-container
                                  *ngFor="let orderItemProductPackageProduct of orderItemProductPackage.orderItemProductPackageProducts">
                                  <span>{{orderItemProductPackageProduct.cost.amount}}</span>
                                </ng-container>
                              </p>
                            </ng-container>
                          </td>
                          <td>
                            <!-- Prices product-->
                            <p>{{(carpetUnitPrice(orderItemProduct))| BackofficeCurrency }}</p>
                            <!-- Prices fabric-->
                            <p *ngIf="orderItemProduct.orderItemProductFabricCollections.length > 0 && checkHasFabric(orderItemProduct.orderItemProductFabricCollections[0])">
                              <ng-container
                                *ngFor="let fabricCollection of orderItemProduct.orderItemProductFabricCollections">
                                {{ (isCustomerPrice ? fabricCollection.cost.customerPrice : fabricCollection.cost.dealerPrice) | BackofficeCurrency }}
                              </ng-container>
                            </p>
                            <!-- price ProductPackage-->
                            <ng-container
                              *ngFor="let orderItemProductPackage of orderItemProduct.orderItemProductPackages;">
                              <ng-container
                                *ngFor="let orderItemProductPackageProduct of orderItemProductPackage.orderItemProductPackageProducts">
                                <p *ngIf="orderItemProductPackage.orderItemProductPackageProducts[0].product">
                                  {{ (isCustomerPrice ? orderItemProductPackageProduct.cost.customerPrice : orderItemProductPackageProduct.cost.dealerPrice) | BackofficeCurrency }}
                                </p>
                              </ng-container>
                            </ng-container>
                          </td>
                          <!-- total-->
                          <td>
                            <p>{{(carpetLineTotal(orderItemProduct))| BackofficeCurrency }}</p>
                            <p *ngIf="orderItemProduct.orderItemProductFabricCollections.length > 0 && checkHasFabric(orderItemProduct.orderItemProductFabricCollections[0])">
                              <ng-container
                                *ngFor="let fabricCollection of orderItemProduct.orderItemProductFabricCollections">
                                {{ (isCustomerPrice ? fabricCollection.totalCost.totalCustomerCost : fabricCollection.totalCost.totalDealerPrice) | BackofficeCurrency }}
                              </ng-container>
                            </p>
                            <!--  ProductPackage-->
                            <ng-container
                              *ngFor="let orderItemProductPackage of orderItemProduct.orderItemProductPackages;">
                              <ng-container
                                *ngFor="let orderItemProductPackageProduct of orderItemProductPackage.orderItemProductPackageProducts">
                                <p *ngIf="orderItemProductPackage.orderItemProductPackageProducts[0].product">
                                  {{ (isCustomerPrice ? orderItemProductPackageProduct.totalCost.totalCustomerCost : orderItemProductPackageProduct.totalCost.totalDealerPrice) | BackofficeCurrency }}
                                </p>
                              </ng-container>
                            </ng-container>
                          </td>
                        </ng-container>
                      </tr>
                      <!--Options: rendered by the recursive #optionCell template at the end of this file-->
                      <ng-container *ngFor="let option of calculateOptions(orderItem, orderItemProduct)">
                        <tr>
                          <td colspan="2">
                            <p class="ms-3">
                              <ng-container [ngTemplateOutlet]="optionCell"
                                            [ngTemplateOutletContext]="{$implicit: [option], col: 'name', parentCurrent: null, oip: orderItemProduct, level: 0}"></ng-container>
                            </p>
                          </td>
                          <td>
                            <p>
                              <ng-container [ngTemplateOutlet]="optionCell"
                                            [ngTemplateOutletContext]="{$implicit: [option], col: 'amount', parentCurrent: null, oip: orderItemProduct, level: 0}"></ng-container>
                            </p>
                          </td>
                          <td>
                            <p>
                              <ng-container [ngTemplateOutlet]="optionCell"
                                            [ngTemplateOutletContext]="{$implicit: [option], col: 'price', parentCurrent: null, oip: orderItemProduct, level: 0}"></ng-container>
                            </p>
                          </td>
                          <td>
                            <p>
                              <ng-container [ngTemplateOutlet]="optionCell"
                                            [ngTemplateOutletContext]="{$implicit: [option], col: 'total', parentCurrent: null, oip: orderItemProduct, level: 0}"></ng-container>
                            </p>
                          </td>
                        </tr>
                      </ng-container>
                      <tr *ngIf="m < orderItem.orderItemProducts.length - 1">
                        <td colspan="5" class="line-product">
                        </td>
                      </tr>
                    </ng-container>
                    <!--total price and divider-->
                    <tr class="divider" *ngIf="orderItem.orderItemProducts">
                      <td class="pt-3"><strong>{{'doctrine.backoffice.order.article_subtotal'| translate}}</strong></td>
                      <td class="pt-3"></td>
                      <td class="pt-3"></td>
                      <td class="pt-3"></td>
                      <td class="pt-3"><strong>{{orderItem.totalArticleDealerPrice | BackofficeCurrency}}</strong></td>
                    </tr>
                  </ng-container>
                  <!--custom row description-->
                  <ng-container *ngFor="let customRow of order.customRows; let i = index;">
                    <tr *ngIf="i == 0"><p></p></tr>
                    <tr [ngClass]="(i == (order.customRows.length - 1)) ? 'divider' : ''">
                      <td><p [ngClass]="(i == (order.customRows.length - 1)) ? 'mb-2' : ''">{{customRow.articleName}}</p></td>
                      <td></td>
                      <td><p
                        [ngClass]="(i == (order.customRows.length - 1)) ? 'mb-2' : ''">{{customRow.amount | number}}</p>
                      </td>
                      <td><p [ngClass]="(i == (order.customRows.length - 1)) ? 'mb-2' : ''">{{customRow.price}}</p></td>
                      <td>
                        <p [ngClass]="(i == (order.customRows.length - 1)) ? 'mb-2' : ''"><strong>{{(customRow.totalPrice) | BackofficeCurrency}}</strong></p>
                      </td>
                    </tr>
                  </ng-container>
                  <ng-container *ngIf="order.transportationCost">
                    <tr><p></p></tr>
                    <tr class="divider">
                      <td><strong>{{'doctrine.order.transportation_costs'|translate}}</strong></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr class="after-divider">
                      <td><p>{{ order.user.invoiceDealer.transportationCostDescription }}</p></td>
                      <td></td>
                      <td><p>&nbsp;</p>
                      </td>
                      <td><p >&nbsp;</p></td>
                      <td>
                        <p><strong>{{(order.transportationCost) | BackofficeCurrency}}</strong></p>
                      </td>
                    </tr>
                  </ng-container>
                  <ng-container *ngIf="order.customerDeliveryAddress?.fullName && !isCustomerPrice">
                    <tr><p></p></tr>
                    <tr class="divider">
                      <td><strong>{{'doctrine.order.delivery_cost_description'|translate}}</strong></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td><p><strong>{{(order.dealerDeliveryCost) | BackofficeCurrency}}</strong></p></td>
                    </tr>
                  </ng-container>
                  <ng-container *ngIf="isCustomerPrice && parseInt(order.deliveryCost) > 0">
                    <tr><p></p></tr>
                    <tr class="divider">
                      <td><strong>{{'doctrine.order.delivery_cost_description'|translate}}</strong></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td><p><strong>{{(order.deliveryCost) | BackofficeCurrency}}</strong></p></td>
                    </tr>
                  </ng-container>
                  <ng-container *ngIf="order.discount.applied > 0 && !isCustomerPrice">
                    <tr><p></p></tr>
                    <tr class="divider">
                      <td><strong>{{'doctrine.order.discount'|translate}}</strong></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr class="after-divider">
                      <td><p>{{order.discount.description}}</p></td>
                      <td></td>
                      <td><p>&nbsp;</p>
                      </td>
                      <td><p >&nbsp;</p></td>
                      <td>
                        <p><strong>-{{(order.discount.applied) | BackofficeCurrency}}</strong></p>
                      </td>
                    </tr>
                  </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row justify-content-end">
            <div class="col-md-3">
              <div class="table-responsive calculator-box">
                <table class="table table-sm">
                  <tr>
                    <td> {{'doctrine.backoffice.order.total_ex-vat'| translate}}</td>
                    <td>{{(isCustomerPrice ? order.totalCost.totalCustomerPrice : order.totalCost.totalDealerPrice) | BackofficeCurrency}}</td>
                  </tr>
                  <tr>
                    <td>{{'doctrine.backoffice.order.vat'| translate}}
                      <!--({{order.orderItems[0].orderItemProducts[0].product.vat.rate}}%)-->
                      ({{order.user.invoiceDealer['salesVatPercentage']}}%)
                    </td>
                    <td>{{(isCustomerPrice ? order.totalCost.totalCustomerVAT : order.totalCost.totalDealerVAT)| BackofficeCurrency}}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>
                        {{'doctrine.backoffice.order.total_price'| translate}}
                      </strong>
                    </td>
                    <td>
                      <strong>{{(isCustomerPrice ? order.totalCost.totalCustomerCost : order.totalCost.totalDealerCost)| BackofficeCurrency}}</strong>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template
          [ngTemplateOutlet]="orderTemplateRef"
          [ngTemplateOutletContext]="{ order: order }">
        </ng-template>
      </app-card>
    </div>
  </div>

  <app-modal-basic #cancelModal *ngIf="order!== undefined && order.orderItems[0]!== undefined ">
    <div class="app-modal-header">
      <h4 class="modal-title">{{ 'global.cancel_order' | translate}}</h4>
      <button type="button" class="close basic-close" (click)="cancelModal.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="app-modal-body">
      <p>{{ 'global.cancel_order_body' | translate}}: <b [innerHTML]="order.orderNo"></b></p>
    </div>
    <div class="app-modal-footer">
      <button type="button" class="btn btn-simple ripple me-4"
              (click)="cancelModal.hide()">{{'global.cancel'|translate}}</button>
      <button type="button" class="btn btn-primary ripple light"
              (click)="cancelOrder()">{{'global.yes'|translate}}</button>
    </div>
  </app-modal-basic>

  <app-modal-basic #passwordModal [dialogClass]="'modal-md'" [hideOnClickOutside]="false">
    <div class="app-modal-header">
      <h4 class="modal-title">{{'admin.send_dealer_password'|translate}}</h4>
      <button type="button" class="close basic-close" (click)="checkPasswordError()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="app-modal-body">
      <form autocomplete="off" #passwordModalForm="ngForm">
        <div class="form-group form-primary">
          <label class="float-label">{{'admin.dealer_password'|translate}}</label>
          <input type="password" autocomplete="off" name="password" #password="ngModel" class="form-control" [(ngModel)]="dealerPassword"
                 required minlength="6">
          <span class="form-bar"></span>
          <div class="messages text-danger"
               *ngIf="password.invalid && password.dirty && password.errors?.required">{{'errors.required'|translate}}{{password.invalid && password.dirty}}</div>
          <div class="messages text-danger"
               *ngIf="password?.errors?.minlength">{{'validators.password.length.min'|translate}}</div>
        </div>
        <div class="app-modal-footer d-flex justify-content-between w-100">
          <button type="button" class="btn btn-simple btn-md ripple"
                  (click)="checkPasswordError()">{{'global.cancel'|translate}}</button>
          <button type="submit" class="btn btn-primary btn-md ripple light"
                  (click)="getCustomerPrice()">{{'global.get_customer_price'|translate}}</button>
        </div>
      </form>
    </div>
  </app-modal-basic>

  <a #downloadLink href="" download style="display: none"></a>
</ng-container>


<!--
  Recursive renderer for an order item's options, mirroring the API's report template
  (templates/report/generateOptions.html.twig) so the screen and the PDF agree.

  An option whose `parent` equals the parent option's `current` value is appended inline
  (comma separated) on the same line; any other option starts its own indented line.
  Recursion is unbounded: the markup this replaced was unrolled to three fixed levels and
  looped grandchildren only under the indented branch, so an option nested below an inlined
  child (e.g. "Different legs: Yes, Metal legs, MB1: ...") was dropped from every column.

  Context: $implicit = options to render, col = 'name' | 'amount' | 'price' | 'total',
  parentCurrent = parent option's `current` (null at top level), oip = the OrderItemProduct,
  level = indentation depth in rem.
-->
<ng-template #optionCell let-options let-col="col" let-parentCurrent="parentCurrent" let-oip="oip"
             let-level="level">
  <ng-container *ngFor="let option of options">
    <span class="pt-3 mb-0" [class.d-block]="!isInlineOption(option, parentCurrent)"
          [style.margin-left.rem]="col === 'name' && !isInlineOption(option, parentCurrent) ? level : 0">
      <ng-container [ngSwitch]="col">
        <ng-container *ngSwitchCase="'name'">
          <ng-container *ngIf="isInlineOption(option, parentCurrent); else optionLabel">, {{option.current}}</ng-container>
          <ng-template #optionLabel>{{option.parent}}: {{option.current}}</ng-template>
        </ng-container>
        <ng-container *ngSwitchCase="'amount'">{{checkType(option) ? option.amount : ''}}</ng-container>
        <ng-container *ngSwitchCase="'price'">
          <ng-container *ngIf="checkType(option) && isCalculatable(oip)">{{(isCustomerPrice ? option.customerPrice : option.dealerPrice) | BackofficeCurrency}}</ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'total'">
          <ng-container *ngIf="checkType(option) && isCalculatable(oip)">{{(isCustomerPrice ? option.totalCustomerPrice : option.totalDealerPrice) | BackofficeCurrency}}</ng-container>
        </ng-container>
      </ng-container>

      <!--the option's fabric always gets its own line, and a spacer in the value columns
          so the lines stay aligned across all four columns-->
      <span class="pt-3 mb-0 d-block" *ngIf="option.fabric"
            [style.margin-left.rem]="col === 'name' ? level + 1 : 0">
        <ng-container *ngIf="col === 'name'; else fabricSpacer">
          {{'doctrine.fabric.fabric'|translate}}: {{option.fabricCollection}}, {{option.fabric}}, {{option.fabricColor}}
        </ng-container>
        <ng-template #fabricSpacer>&nbsp;</ng-template>
      </span>

      <ng-container *ngIf="option.children" [ngTemplateOutlet]="optionCell"
                    [ngTemplateOutletContext]="{$implicit: option.children, col: col, parentCurrent: option.current, oip: oip, level: isInlineOption(option, parentCurrent) ? level : level + 1}"></ng-container>
    </span>
  </ng-container>
</ng-template>
